import AccordionItem from "./components/accordion-item";
import HeroComponent from "./components/hero";
import NavComponent from "./components/nav";
import CarouselComponent from "./components/carousel";
import HTMLEntities from "./components/html-entities";
import DateTime from "./components/datetime";
import DateComponent from "./components/date";
import Overlay from "./components/overlay";
import BookDemoForm from "./components/book-demo-form";
import TimeComponent from "./components/time";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const smoother = ScrollSmoother.create({
  wrapper: "#smooth-wrapper",
  content: "#smooth-content",
  smooth: 1.125,
  effects: true,
});

const Components = {
  "accordion-item": AccordionItem,
  "book-demo-form": BookDemoForm,
  carousel: CarouselComponent,
  date: DateComponent,
  datetime: DateTime,
  hero: HeroComponent,
  "html-entities": HTMLEntities,
  nav: NavComponent,
  overlay: Overlay,
  time: TimeComponent,
};

window.addEventListener("load", () => {
  const components = [...document.querySelectorAll("[data-component]")];
  components.forEach((component) => {
    const type = component.dataset.component;
    if (Components[type]) {
      Components[type](component);
    }
  });
  if (smoother) smoother.refresh();
});

console.log("Removed smooth scrolling.");
